import { Fragment } from 'react';

interface IProps {
  npayIcon: JSX.Element;
  paymentMethod?: string;
  prefixDefaultPayment?: boolean;
  showPaymentMethod?: boolean;
  summaryByType: { type: string; summary: string }[];
}

export default function PromotionInfo({
  npayIcon,
  paymentMethod,
  prefixDefaultPayment = false,
  showPaymentMethod = false,
  summaryByType,
}: IProps) {
  return (
    <>
      {showPaymentMethod &&
        (paymentMethod
          ? `${paymentMethod} 결제 `
          : prefixDefaultPayment && '그 외 결제 ')}
      {summaryByType.map(({ type, summary }, index) => (
        <Fragment key={index}>
          {index > 0 && ' + '}
          {type === 'npay' && npayIcon}
          {summary} 시
        </Fragment>
      ))}
    </>
  );
}
